"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importDefault(require("api"));
var config_1 = __importDefault(require("config"));
var QueriesStore_1 = require("stores/QueriesStore");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var use_stores_1 = require("hooks/use-stores");
var Modal_1 = __importDefault(require("components/core/modal/Modal"));
var AddQueryForm_1 = __importDefault(require("./AddQueryForm"));
var dayjs_1 = __importDefault(require("dayjs"));
var AddQuery = function () {
    var _a = react_1.useState(null), queryData = _a[0], setQueryData = _a[1];
    var _b = react_1.useState(null), attachments = _b[0], setAttachments = _b[1];
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var notification = use_notification_1.useNotification();
    var queriesStore = use_stores_1.useStores().queriesStore;
    var history = react_router_dom_1.useHistory();
    var timeoutRef = react_1.useRef(null);
    react_1.useEffect(function () {
        setQueryData({
            queryType: QueriesStore_1.QueryTypes.PRICE.toString(),
            dueDate: dayjs_1.default().format("YYYY-MM-DD")
        });
    }, []);
    var changeHandler = function (e) {
        var _a;
        setQueryData(__assign(__assign({}, queryData), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var changeCustomerHandler = function (e) {
        var _a;
        var acNumber = e.currentTarget.value;
        setQueryData(__assign(__assign({}, queryData), (_a = {}, _a["chosenAc"] = false, _a["acNumber"] = acNumber, _a)));
        var busyTimeout = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        clearTimeout(timeoutRef.current);
        var optionsArray = [{
                "name": "Select a customer to autofill",
                "acNumber": ""
            }];
        timeoutRef.current = setTimeout(function () { return api_1.default.findCustomer(acNumber, queryData.country, queryData.queryType)
            .then(function (response) {
            var _a;
            if (response.data.length >= 2) {
                for (var i = 0; i < response.data.length; i++) {
                    optionsArray.push(response.data[i]);
                }
            }
            else if (response.data.length === 1) {
                optionsArray = response.data;
            }
            clearTimeout(busyTimeout);
            setBusy(false);
            setQueryData(__assign(__assign({}, queryData), (_a = {}, _a["acNumber"] = response.data.length === 1 ? response.data[0].acNumber : acNumber, _a["chosenAc"] = response.data.length === 1, _a["customerOptions"] = response.data.length === 0 ? [{
                    "name": "No Results found",
                    "acNumber": ""
                }] : acNumber === "" ? [{
                    "name": "Please enter an Ac Number",
                    "acNumber": ""
                }] : optionsArray, _a)));
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data
            });
        }); }, 1500);
    };
    var changeNameHandler = function (e) {
        var _a;
        setQueryData(__assign(__assign({}, queryData), (_a = {}, _a["acNumber"] = e.currentTarget.value, _a["chosenAc"] = true, _a)));
    };
    var changeDeliveryRefHandler = function (e) {
        var _a;
        var deliveryRef = e.currentTarget.value;
        setQueryData(__assign(__assign({}, queryData), (_a = {}, _a["deliveryRef"] = deliveryRef, _a)));
        var busyTimeout = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(function () { return api_1.default.findDeliveryRef(deliveryRef, queryData.country, queryData.queryType)
            .then(function (response) {
            clearTimeout(busyTimeout);
            setBusy(false);
            if (response.data.duplicate) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "There is already a POD Query with this Delivery Ref: " + response.data.number
                });
            }
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data
            });
        }); }, 1500);
    };
    var fileHandler = function (name, files) {
        setAttachments(files);
    };
    var fileErrorHandler = function (error) {
        notification({
            variant: Notification_1.NotificationVariants.ERROR,
            message: error
        });
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var error = null;
        if (queryData === null) {
            error = "Please complete your query";
        }
        if (queryData.queryType === QueriesStore_1.QueryTypes.PRICE.toString()) {
            if (!queryData.productType || queryData.productType.length <= 0) {
                error = "Please enter a product type";
            }
        }
        if (queryData.queryType === QueriesStore_1.QueryTypes.POD.toString()) {
            if (!queryData.dueDate || queryData.dueDate.length <= 0) {
                error = "Please enter a due date";
            }
            if (!queryData.deliveryRef || queryData.deliveryRef.length <= 0) {
                error = "Please enter an sales order reference";
            }
            if (!queryData.salesOrderRef || queryData.salesOrderRef.length <= 0) {
                error = "Please enter an sales order reference";
            }
            if (!queryData.billingRef || queryData.billingRef.length <= 0) {
                error = "Please enter an billing reference";
            }
            if (!queryData.invoiceRef || queryData.invoiceRef.length <= 0) {
                error = "Please enter an invoice reference";
            }
            if (!queryData.deliveryDate || queryData.deliveryDate.length <= 0) {
                error = "Please enter a delivery date";
            }
            if (!queryData.queryReason || queryData.queryReason.length <= 0) {
                error = "Please select a query reason";
            }
        }
        if (attachments === null) {
            error = "Please provide an attachment";
        }
        if (!queryData.comment || queryData.comment.length <= 0) {
            error = "Please enter a comment";
        }
        if (!queryData.acNumber || queryData.acNumber.length <= 0) {
            error = "Please enter the A/C Number";
        }
        if (!queryData.country || queryData.country.length <= 0) {
            error = "Please enter the Country";
        }
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        var formData = new FormData();
        for (var key in queryData) {
            if (queryData.hasOwnProperty(key))
                formData.append(key, queryData[key]);
        }
        for (var i = 0; i < attachments.length; i++) {
            formData.append("attachments[]", attachments[i]);
        }
        var busyTimeout = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        api_1.default.postQuery(formData)
            .then(function (response) {
            console.log(response.data);
            queriesStore.addDataItem(response.data);
            clearTimeout(busyTimeout);
            setBusy(false);
            history.replace("/query/" + response.data.id);
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data
            });
        });
    };
    return (react_1.default.createElement(Modal_1.default, { title: "Query Input" },
        react_1.default.createElement(AddQueryForm_1.default, { busy: busy, queryData: queryData, attachments: attachments, onChange: changeHandler, customerOnChange: changeCustomerHandler, nameOnChange: changeNameHandler, deliveryRefOnChange: changeDeliveryRefHandler, onFilesSelect: fileHandler, onFilesError: fileErrorHandler, onSubmit: submitHandler })));
};
exports.default = AddQuery;
